import { makeAutoObservable } from "mobx";
import { SearchServiceTreatment } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { getCurrentStaff } from "app/common/LocalFunction";
import {
  pagingServiceRequestItem,
  receiveTreatment,
} from "app/services/ServiceRequestItemService";
import i18n from "i18n";
import {
  cancelReceiveMultipleTreatments,
  cancelReceiveTreatment,
  getMultipleServiceRequestItemWithServiceSteps,
  getServiceRequestItemWithServiceSteps,
  saveMultipleServiceRequestItemWithSteps,
  saveServiceRequestItemWithSteps,
} from "app/services/ServiceRequestItemStepService";
import { StepType } from "app/common/Model/ServiceStepModel";
import {
  undoMarkMultipleServiceAsCompletedByServiceRequestItem,
  undoMarkServiceAsCompletedByServiceRequestItem,
} from "app/services/DiagnosticReportService";
import { ThreeSixtyRounded } from "@material-ui/icons";

toast.configure({
  autoClose: 2000,
  draggable: false,
  limit: 3,
});

export default class TreatmentListStore {
  intactSearchObject = {
    ...new SearchServiceTreatment(),
    itemStatus: 0, // Trạng thái yêu cầu,
    pageIndex: 1,
    pageSize: 10,

    orderDateFrom: new Date(new Date().setHours(0, 0, 0, 0)), // Thời gian chỉ định từ
    orderDateTo: (() => new Date(new Date().setHours(23, 59, 59, 999)))(), // Thời gian chỉ định đến
    performDateFrom: null, // Thời gian thực hiện từ
    performDateTo: null, // Thời gian thực hiện đến
    roomId: null, // Phòng thực hiện
    healthCareSvId: null, //id cua dich vu
    performerId: null, // người thực hiện
  };

  searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));
  totalElements = 0;
  totalPages = 0;
  listTreatment = [];
  openCreateEditPopup = false;
  selectedTreatment = null;
  openConfirmDeletePopup = false;
  openConfirmDeleteListPopup = false;
  listChosen = [];
  // handle for update recruitment request status
  openConfirmUpdateStatusPopup = false;
  onUpdateStatus = null;
  selectDepartment = null;
  openDepartmentPopup = false;
  openViewPopup = false;
  selectedRowTreatmentList = [];
  openAssign = false;
  listCoordinate = [];
  openPopupWith = false;
  openConfirmReceiveTreatmentPopup = false;
  openUndoCompleteMultipleTreatmentPopup = false;
  openUndoCompleteTreatmentPopup = false;
  openConfirmMessage = null;
  permissionErrorMessage = null;

  selectedStep = {
    receptionTime: new Date(),
    receptionist: null,
    serviceRequestItems: [
      {
        room: null,
        bed: null,
        performer: null,
        itemStatus: 0,
        serviceRequestItemSteps: [
          {
            serviceStep: null,
            performer: null,
          },
        ],
      },
    ],
  };

  // Cancel
  openCancelPopupAssign = false;
  openCancelPopupAssignWith = false;
  listCoordinateCancel = null;
  listCoordinateCancelWith = null;

  handleClose = () => {
    this.openConfirmMessage = null;
    this.permissionErrorMessage = null;
  };

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedRowTreatmentList = (row) => {
    this.selectedRowTreatmentList = row;
  };

  getSelectedTreatmentIds = () => {
    const ids = [];
    this?.selectedRowTreatmentList?.forEach(function (item) {
      ids.push(item?.id);
    });
    return ids;
  };

  handelOpenAssign = async (state) => {
    try {
      const chosenIds = [...this.getSelectedTreatmentIds()];

      const { data } = await getMultipleServiceRequestItemWithServiceSteps(
        chosenIds
      );
      const staff = getCurrentStaff();
      const encounterParticipants = staff
        ? [
          {
            position: staff?.position,
            staff,
          },
        ]
        : [];
      let formatData =
        data?.length > 0 &&
        data?.map((el) => ({
          ...el,
          performer: el?.performer ? el?.performer : staff,
          encounterParticipants: encounterParticipants,
        }));
      this.listCoordinate = [...formatData];

      this.openAssign = state;
      // console.log("distribute data: ", data);
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };

  handelCloseAssign = () => {
    this.openAssign = false;
    this.openPopupWith = false;
    this.listCoordinate = [];
  };

  handleChangePagingStatus = (approvalStatus) => {
    const so = { ...this.searchObject, approvalStatus: approvalStatus };
    this.searchObject = so;
  };

  handleOpenConfirmReceiveTreatment = async (treatment) => {
    try {
      const { data } = await getServiceRequestItemWithServiceSteps(
        treatment?.id
      );
      const staff = getCurrentStaff();
      const encounterParticipants = staff
        ? [
          {
            position: staff?.position,
            staff,
          },
        ]
        : [];
      this.selectedTreatment = {
        ...data,
        performer: data?.performer ? data?.performer : staff,
        encounterParticipants:
          data?.encounterParticipants?.length > 0
            ? data?.encounterParticipants
            : encounterParticipants,
      };
      this.openPopupWith = true;
    } catch (error) {
      console.error(error);
    }
  };

  handleFilter = async (values) => {
    const newSearchObject = {
      ...this.searchObject,
      ...values,
      pageIndex: 1,
    };

    this.handleSetSearchObject(newSearchObject);
    this.pagingTreatments();
    this.setSelectedRowTreatmentList([]);
  };

  handlePopupWith = () => {
    this.openPopupWith = true;
  };

  handleCloseConfirmReceiveTreatment = () => {
    this.openConfirmReceiveTreatmentPopup = false;
  };

  handleChooseTab = (tab) => {
    const newSO = {
      ...this.searchObject,
      itemStatus: tab,
    };
    this.handleFilter(newSO);
  };

  resetStore = () => {
    this.searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));
    this.totalElements = 0;
    this.totalPages = 0;
    this.listTreatment = [];
    this.openCreateEditPopup = false;
    this.selectedTreatment = null;
    this.openConfirmDeletePopup = false;
    this.openConfirmDeleteListPopup = false;
    this.listChosen = [];
    this.openConfirmUpdateStatusPopup = false;
    this.openDepartmentPopup = false;
    this.onUpdateStatus = null;
    this.openUndoCompleteMultipleTreatmentPopup = false;
    this.openUndoCompleteTreatmentPopup = false;
    this.openConfirmMessage = null;
    this.permissionErrorMessage = null;
  };

  handleSetSearchObject = (searchObject) => {
    if (searchObject.healthCareSv == null) {
      searchObject.healthCareSvId = null;
    } else {
      searchObject.healthCareSvId = searchObject?.healthCareSv?.id;
    }

    this.searchObject = { ...searchObject };
  };

  mapTabToStatus = (tab) => {
    // tab 1 => Mới chỉ định
    if (tab == 0) return 1;
    // tab 2 => Đã tiếp nhận
    if (tab == 1) return 2;
    // tab 2 => Đang thực hiện
    if (tab == 2) return 3;
    // tab 3 => Đã hoàn thành
    if (tab == 3) return 4;

    return null;
  };

  pagingTreatments = async () => {
    const { department, performer, ...ortherData } = this.searchObject;

    // Không call API nếu không có cơ sở (bắt buộc)
    if (!department) {
      this.listTreatment = [];
      this.totalElements = 0;
      this.totalPages = 0;
      return;
    }

    if (department) {
      ortherData.departmentId = department?.id;
    } else {
      ortherData.departmentId = null;
    }

    if (performer) {
      ortherData.performerId = performer?.id;
    } else {
      ortherData.performerId = null;
    }
    try {
      const payload = {
        ...ortherData,
        itemStatus: this.mapTabToStatus(this.searchObject?.itemStatus),
      };
      const data = await pagingServiceRequestItem(payload);

      this.listTreatment = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;
    } catch (error) {
      console.error(error);
      toast.error(i18n.t("toast.error"));
    }
  };

  setPageIndex = async (page) => {
    this.searchObject.pageIndex = page;

    await this.pagingTreatments();
  };

  setPageSize = async (pageSize) => {
    this.searchObject.pageSize = pageSize;
    this.searchObject.pageIndex = 1;

    await this.pagingTreatments();
  };

  handleChangePage = async (newPage) => {
    await this.setPageIndex(newPage);
  };

  handleSelectListDelete = (deleteItems) => {
    this.listChosen = deleteItems;
  };

  handleClose = () => {
    this.openConfirmDeletePopup = false;
    this.openCreateEditPopup = false;
    this.openConfirmUpdateStatusPopup = false;
    this.openConfirmDeleteListPopup = false;
    this.onUpdateStatus = null;
    this.listChosen = [];
    this.openViewPopup = false;
    this.openConfirmMessage = null;
    this.permissionErrorMessage = null;
  };

  handleDelete = (treatment) => {
    this.selectedTreatment = { ...treatment };
    this.openConfirmDeletePopup = true;
  };

  handleDeleteList = () => {
    this.openConfirmDeleteListPopup = true;
  };

  handleSaveServiceSteps = async (Steps) => {
    try {
      const { data } = await saveMultipleServiceRequestItemWithSteps(Steps);
      if (data && data.length > 0 && data[0].responseStatus === false) {
        setTimeout(() => {
          if (data[0].responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data[0].responseDetail;
          } else {
            this.openConfirmMessage = data[0].responseDetail;
          }
        }, 500);
      } else {
        toast.success("Tiếp nhận điều trị thành công!");
        this.handelCloseAssign();
        await this.pagingTreatments();
      }
      return data;
    } catch (error) {
      toast.error("Tiếp nhận điều trị thất bại!");
      console.error("Tiếp nhận điều trị thất bại!:", error);
    }
  };

  handleSaveServiceStepsWith = async (Steps) => {
    try {
      const { data } = await saveServiceRequestItemWithSteps(Steps);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
      } else {
        toast.success("Tiếp nhận điều trị thành công!");
        this.handelCloseAssign();
      }
      return data;
    } catch (error) {
      toast.error("Tiếp nhận điều trị thất bại!");
      console.error("Tiếp nhận điều trị thất bại!:", error);
    }
  };

  getSelectedIds = () => {
    const ids = [];

    this?.listChosen?.forEach(function (item) {
      ids.push(item?.id);
    });

    return ids;
  };

  confirmReceiveTreatment = async (item) => {
    try {
      const { data } = await receiveTreatment(item);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
        return data;
      }
      if (!data?.id) {
        throw new Error();
      }
      toast.success("Đã tiếp nhận");
      return data;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra, vui lòng thử lại");
    }
  };

  // hàm của cancel
  handlePopupCancel = async () => {
    try {
      const chosenIds = [...this.getSelectedTreatmentIds()];
      const { data } = await getMultipleServiceRequestItemWithServiceSteps(
        chosenIds
      );
      this.listCoordinateCancel = data;
      this.openCancelPopupAssign = true;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };

  handlePopupCancelwith = async (treatment) => {
    try {
      const { data } = await getServiceRequestItemWithServiceSteps(
        treatment?.id
      );

      this.listCoordinateCancelWith = data;
      this.openCancelPopupAssignWith = true;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };

  handleCancelService = async (ids) => {
    try {
      const { data } = await cancelReceiveTreatment(ids);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
        return data;
      }
      toast.success("Hủy thành công!");
      this.handleClosePopupCancel();
      await this.pagingTreatments();
      this.clearSelectedRows();
      return data;
    } catch (error) {
      toast.error("Hủy thất bại!");
      console.error("Hủy thất bại!:", error);
    }
  };

  handleCancelServiceAll = async (ids) => {
    try {
      const { data } = await cancelReceiveMultipleTreatments(ids);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
        return data;
      }
      toast.success("Hủy thành công!");
      this.handleClosePopupCancel();
      await this.pagingTreatments();
      this.clearSelectedRows();
      return data;
    } catch (error) {
      toast.error("Hủy thất bại!");
      console.error("Hủy thất bại!:", error);
    }
  };

  clearSelectedRows() {
    this.selectedRowTreatmentList = [];
  }

  handleClosePopupCancel = () => {
    this.openCancelPopupAssign = false;
    this.openCancelPopupAssignWith = false;
    this.openUndoCompleteMultipleTreatmentPopup = false;
    this.openUndoCompleteTreatmentPopup = false;
    this.selectedTreatment = null;
  };

  handleOpenUndoCompleteTreatmentPopup = (treatment) => {
    this.selectedTreatment = {
      ...treatment,
    };

    this.openUndoCompleteTreatmentPopup = true;
  };

  handleConfirmUndoCompleteTreatment = async () => {
    if (!this?.selectedTreatment?.id) {
      return;
    }

    try {
      const { data } = await undoMarkServiceAsCompletedByServiceRequestItem(
        this?.selectedTreatment?.id
      );

      if (data?.responseStatus === false) {
        this.handleClosePopupCancel();
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
      } else {
        this.handleClosePopupCancel();

        toast.success("Đã hủy hoàn thành điều trị");
        this.pagingTreatments();
      }

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Hủy đánh dấu hoàn thành điều trị có lỗi");
    }
  };

  handleOpenUndoCompleteMultipleTreatmentPopup = () => {
    this.openUndoCompleteMultipleTreatmentPopup = true;
  };

  handleConfirmUndoCompleteMultipleTreatment = async () => {
    try {
      const chosenIds = [...this.getSelectedTreatmentIds()];

      const { data } =
        await undoMarkMultipleServiceAsCompletedByServiceRequestItem(chosenIds);

      if (
        data &&
        Array.isArray(data) &&
        data.some((item) => item.responseStatus === false)
      ) {
        this.handleClosePopupCancel();
        const errorItem = data.find((item) => item.responseStatus === false);
        setTimeout(() => {
          if (errorItem.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = errorItem.responseDetail;
          } else {
            this.openConfirmMessage =
              errorItem.responseDetail ||
              "Hủy đánh dấu hoàn thành điều trị thất bại!";
          }
        }, 500);
      } else {
        this.handleClosePopupCancel();
        this.pagingTreatments();

        toast.success("Đã hủy hoàn thành điều trị");
      }

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Hủy đánh dấu hoàn thành điều trị có lỗi");
    }
  };
}
